module.exports = __webpack_public_path__ + "static/media/expert-finalbacground.cf71f0d5.png";